import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "product-card__image-wrapper" }
const _hoisted_3 = { class: "ds-aspect-ratio ds-aspect-ratio--appearance_filled ds-aspect-ratio--ratio_4x4" }
const _hoisted_4 = { class: "ds-aspect-ratio__body" }
const _hoisted_5 = {
  key: 0,
  class: "image-wrapper"
}
const _hoisted_6 = ["srcset"]
const _hoisted_7 = ["src", "alt", "title"]
const _hoisted_8 = {
  key: 1,
  class: "image-wrapper"
}
const _hoisted_9 = ["src", "alt", "title"]
const _hoisted_10 = { class: "product-card__main" }
const _hoisted_11 = { class: "product-card__content" }
const _hoisted_12 = { class: "product-card__title line-clamp line-clamp--line_1" }
const _hoisted_13 = ["title"]
const _hoisted_14 = { class: "product-card__variants product-card__variants--search" }
const _hoisted_15 = { class: "product-card__attribute" }
const _hoisted_16 = { class: "ds-panel ds-panel--space_xs" }
const _hoisted_17 = { class: "ds-panel__element ds-panel__element--offset_bottom" }
const _hoisted_18 = { class: "ds-caption ds-caption--size_2xxs ds-caption--size_xs-lg ds-caption--color_relief-5" }
const _hoisted_19 = { class: "g-row g-row--appearance_spaced g-row--space_xs" }
const _hoisted_20 = { class: "g-cell g-cols" }
const _hoisted_21 = ["href"]
const _hoisted_22 = {
  key: 0,
  class: "color-circle__checkmark"
}
const _hoisted_23 = { class: "color-circle__image" }
const _hoisted_24 = { class: "image-wrapper" }
const _hoisted_25 = ["src", "alt", "title"]
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "product-card__footer" }
const _hoisted_28 = { class: "product-card__price" }
const _hoisted_29 = {
  key: 0,
  class: "ds-caption ds-caption--size_2xs ds-caption--size_sm-xl ds-caption--color_relief-5 ds-caption--appearance_through"
}
const _hoisted_30 = { class: "ds-caption ds-caption--size_md-xl ds-caption--size_lg-xl ds-caption--weight_bold" }
const _hoisted_31 = { class: "product-card__button" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "control-button__icon control-button__icon--space_none" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "control-button__icon control-button__icon--space_none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_checkmark = _resolveComponent("icon-checkmark")!
  const _component_icon_cart = _resolveComponent("icon-cart")!
  const _component_cart_button_add = _resolveComponent("cart-button-add")!
  const _component_icon_clock = _resolveComponent("icon-clock")!
  const _component_modal_trigger = _resolveComponent("modal-trigger")!

  return (_openBlock(), _createElementBlock("a", {
    class: "product-card product-card--variant_horizontal",
    href: $props.item.url
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          ($props.item.preview)
            ? (_openBlock(), _createElementBlock("picture", _hoisted_5, [
                _createElementVNode("source", {
                  type: "image/webp",
                  srcset: $props.item.previewWebp
                }, null, 8, _hoisted_6),
                _createElementVNode("img", {
                  class: "image-wrapper__item",
                  src: $props.item.preview,
                  alt: $props.item.name,
                  title: $props.item.name
                }, null, 8, _hoisted_7)
              ]))
            : (_openBlock(), _createElementBlock("picture", _hoisted_8, [
                _createElementVNode("img", {
                  class: "image-wrapper__item",
                  src: $setup.placeholderImage,
                  alt: $props.item.name,
                  title: $props.item.name
                }, null, 8, _hoisted_9)
              ]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("p", {
            class: "ds-caption ds-caption--size_2xs ds-caption--size_md-xl ds-caption--weight_bold",
            title: $props.item.name
          }, _toDisplayString($props.item.name), 9, _hoisted_13)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item?.variantsMap?.attributes, (attr) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("p", _hoisted_18, _toDisplayString(attr.attribute.title), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attr.values, (variant) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  (variant.preview)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: _normalizeClass(["color-circle", {'events-none': variant.isActive, 'is-opacity': !variant.isAvailable && attr.values.length > 1}]),
                        href: variant.variant.url
                      }, [
                        (variant.isActive)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                              _createVNode(_component_icon_checkmark)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_23, [
                          _createElementVNode("picture", _hoisted_24, [
                            _createElementVNode("img", {
                              class: "image-wrapper__item image-wrapper__item--fit",
                              src: variant.preview,
                              alt: variant.title,
                              title: variant.title
                            }, null, 8, _hoisted_25)
                          ])
                        ])
                      ], 10, _hoisted_21))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: _normalizeClass(["i-tag i-tag--variant_2", {'is-active events-none': variant.isActive, 'is-opacity': !variant.isAvailable && attr.values.length > 1}]),
                        href: variant.variant.url
                      }, _toDisplayString(variant.title), 11, _hoisted_26))
                ]))
              }), 256))
            ])
          ]))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          ($props.item.oldPrice)
            ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_ctx.$filters.formatPrice($props.item.oldPrice)) + " " + _toDisplayString(_ctx.$t("€")), 1))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$filters.formatPrice($props.item.price)) + " " + _toDisplayString(_ctx.$t("€")) + "/" + _toDisplayString($props.item.unit), 1)
        ]),
        _createElementVNode("div", _hoisted_31, [
          ($props.item.inStock)
            ? (_openBlock(), _createBlock(_component_cart_button_add, {
                key: 0,
                "item-id": $props.item.id,
                type: $props.item.type
              }, {
                default: _withCtx((props) => [
                  _createElementVNode("div", {
                    class: "control-button control-button--variant_square control-button--variant_grey",
                    onClick: _withModifiers(($event: any) => (props.addToCart()), ["prevent"])
                  }, [
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_component_icon_cart)
                    ])
                  ], 8, _hoisted_32)
                ]),
                _: 1
              }, 8, ["item-id", "type"]))
            : (_openBlock(), _createBlock(_component_modal_trigger, {
                key: 1,
                component: "Modals/Common/ModalFeedback",
                classes: ['modal--size_md']
              }, {
                default: _withCtx(({ open }) => [
                  _createElementVNode("div", {
                    class: "control-button control-button--variant_square control-button--variant_grey control-button--variant_grey-stroke",
                    onClick: _withModifiers(open, ["prevent"])
                  }, [
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_icon_clock)
                    ])
                  ], 8, _hoisted_34)
                ]),
                _: 1
              }))
        ])
      ])
    ])
  ], 8, _hoisted_1))
}